// elevation.ts
export const elevationTokens = {
  "elevation": {
    "level0": {
      "shadow": {
        "value": "none",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "none",
          "type": "boxShadow"
        },
        "name": "ElevationLevel0Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level0",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level0",
          "shadow"
        ]
      }
    },
    "level1": {
      "shadow": {
        "value": "0px 1px 2px rgba(0,0,0,0.3)",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "0px 1px 2px rgba(0,0,0,0.3)",
          "type": "boxShadow"
        },
        "name": "ElevationLevel1Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level1",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level1",
          "shadow"
        ]
      }
    },
    "level2": {
      "shadow": {
        "value": "0px 2px 6px rgba(0,0,0,0.3)",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "0px 2px 6px rgba(0,0,0,0.3)",
          "type": "boxShadow"
        },
        "name": "ElevationLevel2Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level2",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level2",
          "shadow"
        ]
      }
    },
    "level3": {
      "shadow": {
        "value": "0px 4px 12px rgba(0,0,0,0.35)",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "0px 4px 12px rgba(0,0,0,0.35)",
          "type": "boxShadow"
        },
        "name": "ElevationLevel3Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level3",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level3",
          "shadow"
        ]
      }
    },
    "level4": {
      "shadow": {
        "value": "0px 6px 16px rgba(0,0,0,0.4)",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "0px 6px 16px rgba(0,0,0,0.4)",
          "type": "boxShadow"
        },
        "name": "ElevationLevel4Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level4",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level4",
          "shadow"
        ]
      }
    },
    "level5": {
      "shadow": {
        "value": "0px 8px 24px rgba(0,0,0,0.45)",
        "type": "boxShadow",
        "filePath": "design-tokens/elevation.json",
        "isSource": true,
        "original": {
          "value": "0px 8px 24px rgba(0,0,0,0.45)",
          "type": "boxShadow"
        },
        "name": "ElevationLevel5Shadow",
        "attributes": {
          "category": "elevation",
          "type": "level5",
          "item": "shadow"
        },
        "path": [
          "elevation",
          "level5",
          "shadow"
        ]
      }
    }
  }
} as const;

export type ElevationTokens = typeof elevationTokens;
